import { createMemoryHistory } from 'react-router';

import createEntry from 'common/core/createEntry';

import ChangelogWidgetApp from './ChangelogWidgetApp';
import ChangelogWidgetReducers from './ChangelogWidgetReducers';

const GA4MeasurementID = 'G-R4N8476XCQ';
const SentryDSN = 'f570e310f1fc490b800618421304ca31';

const memoryHistory = createMemoryHistory({
  entries: [window.location],
});

createEntry({
  app: ChangelogWidgetApp,
  ga4MeasurementID: GA4MeasurementID,
  history: memoryHistory,
  reducers: ChangelogWidgetReducers,
  sentryDSN: SentryDSN,
});
